import React from 'react'

class Divider extends React.Component{
    render(){
        return(
                <hr
                    style={{
                        color: '#e056fd',
                       
                        height: 1,
                    }}
                />  
        )
    }
}


export default Divider;
